export default "__VITE_ASSET__xnVwslqq__"